import { proxy } from "valtio";

export type ModeOfSaleRow = { designation: string; state: boolean };

export type SalesModes = Partial<{
    customerTicketSalesModes: ModeOfSaleRow[];
    customerInformationCompany: ModeOfSaleRow[];
    customerInformationCity: ModeOfSaleRow[];
    customerInformationName: ModeOfSaleRow[];
    customerInformationNumTel: ModeOfSaleRow[];
    customerInformationAddress: ModeOfSaleRow[];
    customerInformationCode: ModeOfSaleRow[];
    salesCustomerAddressModeSale: ModeOfSaleRow[];
    customerTicket: ModeOfSaleRow[];
    kitchenTicket: ModeOfSaleRow[];
}>;

export type FormData = Record<string, unknown>;

type OrchestratorStoreType = {
    dataGeneral: FormData;
    dataDivers: FormData;
    dataKitchenTicket: FormData;
    dataCustomerTicket: FormData;
    dataFirstTicket: FormData;
    dataSecondTicket: FormData;
    dataThreedTicket: FormData;
    dataFourthTicket: FormData;
    dataFifthTicket: FormData;
    isValidated: boolean;
    checkboxIcon: boolean;
    checkboxIconSecondModel: boolean;
    checkboxIconThreedModel: boolean;
    checkboxIconFourthModel: boolean;
    checkboxIconFifthModel: boolean;
    salesModes: SalesModes;
};

const ORCHESTRATOR_DEFAULTS: OrchestratorStoreType = {
    dataGeneral: {},
    dataDivers: {},
    dataKitchenTicket: {},
    dataCustomerTicket: {},
    dataFirstTicket: {},
    dataSecondTicket: {},
    dataThreedTicket: {},
    dataFourthTicket: {},
    dataFifthTicket: {},
    isValidated: false,
    checkboxIcon: false,
    checkboxIconSecondModel: false,
    checkboxIconThreedModel: false,
    checkboxIconFourthModel: false,
    checkboxIconFifthModel: false,
    salesModes: {},
};

export const orchestratorStore = proxy<OrchestratorStoreType>({
    ...ORCHESTRATOR_DEFAULTS,
});

export function setSalesModes(value: SalesModes): void {
    orchestratorStore.salesModes = value;
}
export function setDataGeneral(value: FormData): void {
    orchestratorStore.dataGeneral = value;
}
export function setDataDivers(value: FormData): void {
    orchestratorStore.dataDivers = value;
}
export function setDataKitchenTicket(value: FormData): void {
    orchestratorStore.dataKitchenTicket = value;
}
export function setDataCustomerTicket(value: FormData): void {
    orchestratorStore.dataCustomerTicket = value;
}
export function setDataFirstTicket(value: FormData): void {
    orchestratorStore.dataFirstTicket = value;
}
export function setDataSecondTicket(value: FormData): void {
    orchestratorStore.dataSecondTicket = value;
}
export function setDataThreedTicket(value: FormData): void {
    orchestratorStore.dataThreedTicket = value;
}
export function setDataFourthTicket(value: FormData): void {
    orchestratorStore.dataFourthTicket = value;
}
export function setDataFifthTicket(value: FormData): void {
    orchestratorStore.dataFifthTicket = value;
}
export function setIsValidateClicked(value: boolean): void {
    orchestratorStore.isValidated = value;
}
export function setCheckboxIcon(value: boolean): void {
    orchestratorStore.checkboxIcon = value;
}
export function setCheckboxIconSecondModel(value: boolean): void {
    orchestratorStore.checkboxIconSecondModel = value;
}
export function setCheckboxIconThreedModel(value: boolean): void {
    orchestratorStore.checkboxIconThreedModel = value;
}
export function setCheckboxIconFourthModel(value: boolean): void {
    orchestratorStore.checkboxIconFourthModel = value;
}
export function setCheckboxIconFifthModel(value: boolean): void {
    orchestratorStore.checkboxIconFifthModel = value;
}

export function resetOrchestratorStore(): void {
    Object.assign(orchestratorStore, ORCHESTRATOR_DEFAULTS);
}
